<div class="container-ad">
  <span class="font-12 weight-600">Configurar conexão com Active Directory (AD)</span>
  <div class="flex gap-35 margin-top-25">
    <div class="flex-direction-column gap-15">
      <div>
        <app-slide-toggle-padrao [carregandoInfo]="carregando" [valor]="activeDirectory.ativo" (changeValue)="activeDirectory.ativo = $event"></app-slide-toggle-padrao>
      </div>
      <div class="flex-direction-column gap-15 width-100">
        <div class="flex gap-15">
          <app-form-field label="Nome" heightFormField="35px" [widthFormField]="'clamp(180px, 15vw, 250px)'" [carregandoInfo]="carregando" [value]="activeDirectory.nome" (changeValue)="activeDirectory.nome = $event"></app-form-field>
          <app-form-field label="Domínio" heightFormField="35px" [widthFormField]="'clamp(180px, 15vw, 250px)'" [carregandoInfo]="carregando" [value]="activeDirectory.dominio" (changeValue)="activeDirectory.dominio = $event"></app-form-field>
        </div>
        <div class="flex gap-15">
          <app-form-field label="Ldap_Url" heightFormField="35px" [widthFormField]="'clamp(180px, 15vw, 250px)'" [carregandoInfo]="carregando" [value]="activeDirectory.ldapUrl" (changeValue)="activeDirectory.ldapUrl = $event"></app-form-field>
          <app-form-field label="Ldap_Manager_Filter" heightFormField="35px" [widthFormField]="'clamp(180px, 15vw, 250px)'" [carregandoInfo]="carregando" [value]="activeDirectory.ldapManagerFilter" (changeValue)="activeDirectory.ldapManagerFilter = $event"></app-form-field>
        </div>
        <div class="flex gap-15">
          <app-form-field label="Ldap_Manager_Base" heightFormField="35px" [widthFormField]="'clamp(180px, 15vw, 250px)'" [carregandoInfo]="carregando" [value]="activeDirectory.ldapManagerBase" (changeValue)="activeDirectory.ldapManagerBase = $event"></app-form-field>
          <app-form-field label="Ldap_Manager_Dn" heightFormField="35px" [widthFormField]="'clamp(180px, 15vw, 250px)'" [carregandoInfo]="carregando" [value]="activeDirectory.ldapManagerDn" (changeValue)="activeDirectory.ldapManagerDn = $event"></app-form-field>
        </div>
        <div class="flex gap-15">
          <app-form-field label="Ldap_Manager_Password" heightFormField="35px" [widthFormField]="'clamp(180px, 15vw, 250px)'" [isSenha]="true" [carregandoInfo]="carregando" [value]="activeDirectory.ldapManagerPassword" (changeValue)="activeDirectory.ldapManagerPassword = $event"></app-form-field>
        </div>
      </div>
      <div class="flex gap-5 width-100 margin-top-25">
        <app-button-padrao width="clamp(110px, 7.5vw, 130px)" label="Testar Conexão" backgroundColor="'#fff'" [borderStyle]="'solid'" [borderWidth]="'1px'" [borderColor]="'var(--verde-padrao)'" color="var(--verde-padrao)" (buttonClick)="testarConexao()"></app-button-padrao>
        <app-button-padrao width="clamp(110px, 7.5vw, 130px)" label="Salvar" backgroundColor="var(--verde-padrao)" color="white" (buttonClick)="salvar()"></app-button-padrao>
      </div>
    </div>
    <div class="flex-direction-column gap-15">
      @if (erroConexao) {
        <div class="container-informativo" style="background-color: #E4040438; color: #E40404">
          <div class="flex align-center gap-5">
            <img src="./assets/icones/chat_error.svg" alt="" style="width: 24px; height: 24px">
            <span class="font-14 weight-600">Erro de Conexão</span>
          </div>
          <div>
            <span class="font-12">Liberar acesso externo ao AD somente para o o link app.claribot.com.br e criar uma porta para não disponibilizar a porta padrão.</span>
          </div>
        </div>
      }
      <div class="container-informativo" style="background-color: #347FAA24; color: #347FAA">
        <div class="flex align-center gap-5">
          <img src="./assets/icones/feedback.svg" alt="" style="width: 24px; height: 24px">
          <span class="font-14 weight-600">Dica de Segurança</span>
        </div>
        <div>
          <span class="font-12">Liberar acesso externo ao AD somente para o link app.claribot.com.br e criar uma portão para não disponibilizar a porta padrão.</span>
        </div>
      </div>
    </div>
  </div>
</div>
